export const Logo = ({ size = 36, withWordmark = true, wordmarkClass = "", symbolClass = "" }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <img
      src="/assets/logo.png"
      alt="Harman AI Solutions logo"
      style={{ height: size, width: "auto" }}
      className={`object-contain drop-shadow-[0_0_12px_rgba(0,168,255,0.5)] ${symbolClass}`}
    />
    {withWordmark && (
      <span className={`font-extrabold tracking-tight whitespace-nowrap ${wordmarkClass}`}>
        <span className="text-[#F7FAFF]">Harman </span>
        <span className="text-gradient">AI</span>
        <span className="text-[#AEBFD8] font-medium"> Solutions</span>
      </span>
    )}
  </div>
);
